import { ExpensePeriod } from "../../expense/expense-reriod";


export class responseGetExpensePeriod {
    list:Array<ExpensePeriod>;
    constructor(data) {
        this.list = data.map(item => new ExpensePeriod(item));
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/http/res/response-get-expense-reriod.ts